import React, { useState, useEffect } from "react";
import {
    mdiHome,
    mdiChevronDoubleRight,
    mdiDelete,
    mdiCartArrowDown,
    mdiPlus,
    mdiPrinter,
    mdiCurrencyUsd,
    mdiClose,
} from "@mdi/js";
import Icon from "@mdi/react";
import NumberFormat from "react-number-format";
import { getBranch } from "utils/utils";
import numeral from "numeral";
import { CustomerParseFloat } from "utils/currencyFormat";
import { convertToNumber } from "utils/currencyFormat";
import { pushNotification } from "utils/notifications";
import Trash from "../../../Resources/ImagesNew/IconTable/trash.png";
import { formatNumber } from "utils/currencyFormat";
import { BtnSuaGia } from "./SuaGia/BtnSuaGia";
import { DateTimePicker } from "react-widgets";
import moment from "moment";
import { AutocompleteMaHang } from "./AutocompleteMaHang";
import { convertDate } from "utils/currencyFormat";
import { LamTronNghin } from "utils/utils";
import { formatNumber2Digits } from "utils/currencyFormat";
import DatHangApi from "../../../service/DatHang/DatHangApi";
import BtnChiTietSp from "./ChiTietSp/BtnChiTietSp";
import DanhMucNewApi from "../../../service/DanhMucNewApi";

export const TableSanPham = ({
    dataBanHang,
    isKGCXaGo,
    setDataBanHang,
    objDataStore,
    sCode,
    disEditDonGia,
    disEditAll,
    listNhomSP,
    setListNhomSP,
    setListChietKhauNhom,
    listChietKhauNhom,
    lamTron,
    GoiPhanMem,
    HienthiAutotrukhogiacong,
    tatCanhBaoLuongTon,
    isNhapThueGTGT,
    isShowGiaBan,
    valueSanPham,
    setValueSanPham,
    isCanhBaoBanGiaTrungBinh,
    isNhapCongThucNhanhTTK,
    roleBanCuon,
    roleMaMc,
    roleGiaVon,
    roleSuaSP,
    isSuaDonBanGiaoNhan,
}) => {
    console.log(dataBanHang.lstChiTiet, "dataBanHang.lstChiTiet");
    const TinhTong = () => {
        const obj = { ...dataBanHang };
        obj.TotalAmount = 0;
        obj.TotalAmountNew = 0;
        obj.TotalAmountThueGTGT = 0;
        if (obj.lstChiTiet.length > 0) {
            var lstNew = obj.lstChiTiet.map((category, index) => {
                var tong = 0;
                var strAttribute = "";
                var valueAttribute = 0;
                var AttributeDonVi = "";
                var sDonVi = "";
                var checkAttr = false;
                category.ValueOfUnitForExportPrice = (
                    category.ValueOfUnitForExportPrice + ""
                )
                    .replace(/,/g, "")
                    .replace(/-/g, "");
                if (category.Attributes.length > 0) {
                    var attrMain = category.Attributes.find(
                        (e) => e.AttributeID === category.IdDonViXuat
                    );

                    if (
                        typeof category.LstDonViNhap != "undefined" &&
                        typeof attrMain != "undefined"
                    ) {
                        var attrChon = category.LstDonViNhap.find(
                            (e) => e.AttributeID === category.IdDonViXuatView
                        );
                        attrChon.Values = category.ValueOfUnitForExportPrice;
                        attrChon.isCheck = true;
                        if (attrMain != null) {
                            let index = 0;
                            category.Attributes.map((Attribute, i) => {
                                if (Attribute.AttributeID == category.IdDonViXuat) {
                                    index = i;
                                }
                            });
                            category.ValueOfUnitForExportPrice = attrMain.Values;
                            category.Attributes.splice(index, 1);
                            category.Attributes.push(attrChon);
                        }
                    }
                    if (valueAttribute == 0) {
                        category.Attributes.map((Attribute, i) => {
                            if (Attribute.isCheck) {
                                valueAttribute = Attribute.Values;
                                AttributeDonVi = Attribute.Name;
                            }
                        });
                    }
                    category.Attributes.map((Attribute, index) => {
                        if (Attribute.Values && Attribute.isCheck) {
                            if (strAttribute != "") {
                                strAttribute =
                                    strAttribute +
                                    ", " +
                                    formatNumber(Attribute.Values) +
                                    " " +
                                    Attribute.Name;
                            } else {
                                strAttribute =
                                    "(" + formatNumber(Attribute.Values) + " " + Attribute.Name;
                            }
                        }
                    });
                    if (strAttribute != "") {
                        strAttribute = strAttribute + ")";
                    }
                }
                category.strAttribute = strAttribute;
                if (
                    category.DonVi != null &&
                    category.DonVi != "" &&
                    typeof category.DonVi != "undefined"
                ) {
                    sDonVi = category.DonVi;
                } else if (category.DonViGiaCong != null) {
                    sDonVi = category.DonViGiaCong;
                } else {
                    sDonVi = category.DonViXuat;
                    if (typeof sDonViXuat === "undefined") {
                        sDonVi = category.DonViNhap;
                    }
                }
                if (valueAttribute != 0) {
                    sDonVi = AttributeDonVi;
                    if (category.ShowQuantity) {
                        tong = valueAttribute * CustomerParseFloat(category.Quantity);
                    } else {
                        tong = valueAttribute;
                    }
                } else {
                    if (category.ShowQuantity) {
                        tong =
                            CustomerParseFloat(category.ValueOfUnitForExportPrice) *
                            CustomerParseFloat(category.Quantity) *
                            category.RateForSale;
                    } else {
                        tong =
                            CustomerParseFloat(category.ValueOfUnitForExportPrice) *
                            category.RateForSale;
                    }
                }
                tong = CustomerParseFloat(numeral(tong));
                category.Tong = CustomerParseFloat(numeral(tong));
                //
                category.SLDonViBan = category.ValueOfUnitForExportPrice;
                category.ExportPrice = numeral(category.ExportPrice)
                    .format("0.[0000]")
                    .doidau();
                const totalXuat = category.Price * category.Tong;
                dataBanHang.TotalAmount = LamTronNghin(
                    dataBanHang.TotalAmount + category.Price * category.Tong,
                    lamTron
                );

                const sumQuantityExportXuat = dataBanHang.lstChiTiet.reduce(function (
                    total,
                    current
                ) {
                    var tongNew = 0;
                    var valueAttributeNew = 0;
                    var AttributeDonViNew = "";
                    if (current.Attributes.length > 0) {
                        if (valueAttributeNew == 0) {
                            current.Attributes.map((Attribute, i) => {
                                if (Attribute.isCheck) {
                                    valueAttributeNew = Attribute.Values;
                                    AttributeDonViNew = Attribute.Name;
                                }
                            });
                        }
                    }
                    if (valueAttributeNew != 0) {
                        if (current.ShowQuantity) {
                            tongNew =
                                valueAttributeNew * CustomerParseFloat(current.Quantity);
                        } else {
                            tongNew = valueAttributeNew;
                        }
                    } else {
                        if (current.ShowQuantity) {
                            tongNew =
                                CustomerParseFloat(current.ValueOfUnitForExportPrice) *
                                CustomerParseFloat(current.Quantity) *
                                current.RateForSale;
                        } else {
                            tongNew =
                                CustomerParseFloat(current.ValueOfUnitForExportPrice) *
                                current.RateForSale;
                        }
                    }
                    tongNew = CustomerParseFloat(numeral(tongNew));
                    return total + +tongNew;
                },
                    0);
                category.tongNew = sumQuantityExportXuat;
                const newGTGT =
                    convertToNumber(dataBanHang.ChietKhau) / sumQuantityExportXuat;
                const newPrice = category.ExportPrice - newGTGT;
                const GTGTXuat = category.ThueGTGT / 100;
                category.PriceGTGT = newPrice * GTGTXuat * category.Tong;
                dataBanHang.TotalAmountThueGTGT = LamTronNghin(
                    numeral(
                        CustomerParseFloat(dataBanHang.TotalAmountThueGTGT) +
                        CustomerParseFloat(category.PriceGTGT)
                    ).format("0"),
                    lamTron
                );
                dataBanHang.TotalAmountNew = LamTronNghin(
                    CustomerParseFloat(dataBanHang.TotalAmount) +
                    CustomerParseFloat(dataBanHang.TotalAmountThueGTGT),
                    lamTron
                );
            });
            obj.lstChiTiet = lstNew;
            setDataBanHang(obj);
        }
    };

    const onChangeKho = (field, e, index) =>
        updateKhoID(field, e.target.value, index);
    const updateKhoID = (field, value, index) => {
        const obj = { ...dataBanHang };
        var lstNew = obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                cate[field] = value;
            }
            return cate;
        });
        obj.lstChiTiet = lstNew;
        setDataBanHang(obj);
        // TinhTong();
    };

    //Gia công
    const onChangeOption = (field, e, index) =>
        updateDanhSachOption(e.target.value, field, index);
    // const updateDanhSachOption = (value, field, index) => {
    //   const obj = { ...dataBanHang };
    //   var lstNew = obj.lstChiTiet.map(async (cate, i) => {
    //     if (index === i) {
    //       cate[field] = value;
    //       if (value != "0") {
    //         debugger
    //         let _customerId = dataBanHang.CustomerID;
    //         if (_customerId == null || _customerId == undefined) {
    //           _customerId = 0;
    //         }
    //         try {
    //           const response = await BanHangApi.getOptionForOrder(value, cate.CategoryID, _customerId, getBranch());
    //           if (response.status === 200 && response.data) {
    //             const enOption = response.data;
    //             cate.RateForSale = enOption.RateForSale;
    //             cate.OptionID = enOption.OptionID;
    //             cate.DonVi = enOption.DonVi;
    //             cate.ImportPrice = cate.ImportPriceOld;
    //             cate.ExportPrice = enOption.Price;
    //             cate.Price = enOption.Price;
    //             cate.GiaGoc = cate.Price;
    //           }
    //         } catch (error) {
    //           console.error("Lỗi khi lấy option:", error);
    //         }

    //         // var obj = cate.Options.find(
    //         //   (e) => e.OptionID == convertToNumber(value)
    //         // );

    //         // cate.RateForSale = obj.RateForSale;
    //         // cate.OptionID = obj.OptionID;
    //         // cate.DonVi = obj.DonVi;
    //         // cate.ImportPrice = cate.ImportPriceOld;
    //         // cate.ExportPrice = obj.Price;
    //         // cate.Price = obj.Price;
    //         // cate.GiaGoc = cate.Price;
    //       } else {
    //         cate.RateForSale = 1;
    //         cate.OptionID = 0;
    //         cate.DonVi = "";
    //         cate.ImportPrice = cate.ImportPriceOld;
    //         cate.ExportPrice = cate.Price;
    //         cate.Price = cate.PriceOld;
    //         cate.GiaGoc = cate.Price;
    //       }
    //     }
    //     return cate;
    //   });
    //   obj.lstChiTiet = lstNew;
    //   setDataBanHang(obj);
    //   //// TinhTong();
    // };


    const updateDanhSachOption = async (value, field, index) => {
        const obj = { ...dataBanHang };

        // copy danh sách chi tiết
        const lstNew = [...obj.lstChiTiet];

        if (index < 0 || index >= lstNew.length) return;

        const cate = { ...lstNew[index] }; // clone để không mutate trực tiếp

        cate[field] = value;

        if (value !== "0") {
            try {
                const response = await DatHangApi.getOptionForOrder(
                    value,
                    cate.CategoryID,
                    1
                );

                if (response.status === 200 && response.data) {
                    const enOption = response.data;

                    cate.RateForSale = enOption.RateForSale;
                    cate.OptionID = enOption.OptionID;
                    cate.DonVi = enOption.DonVi;
                    cate.ImportPrice = cate.ImportPriceOld;
                    cate.ExportPrice = enOption.Price;
                    cate.Price = enOption.Price;
                    cate.GiaGoc = cate.Price;
                }
            } catch (error) {
                console.error("Lỗi khi lấy option:", error);
            }
        } else {
            cate.RateForSale = 1;
            cate.OptionID = 0;
            cate.DonVi = "";
            cate.ImportPrice = cate.ImportPriceOld;
            cate.ExportPrice = cate.Price;
            cate.Price = cate.PriceOld;
            cate.GiaGoc = cate.Price;
        }

        lstNew[index] = cate; // gán lại vào vị trí index
        obj.lstChiTiet = lstNew;

        setDataBanHang(obj);
    };



    const DeleteCategory = (index) => {
        const obj = { ...dataBanHang };
        obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                const lstCkNew = listChietKhauNhom.map((cateDetail, ii) => {
                    if (cate.IdNhomSPCha === cateDetail.IdNhomSPCha) {
                        if (cate.Attributes.length > 0 && cate.IdNhomSPCha !== 0) {
                            var ChietKhauTheoKG = cate.Attributes.find(
                                (e) => e.Name.toLowerCase().trim() === "kg"
                            );
                            if (typeof ChietKhauTheoKG === "undefined") {
                                return null;
                            }
                            cateDetail.SoLuong =
                                convertToNumber(cateDetail.SoLuong) -
                                convertToNumber(ChietKhauTheoKG.Values);
                        }
                    }
                    return cateDetail;
                });
                setListChietKhauNhom(lstCkNew);
            }
        });
        obj.lstChiTiet.splice(index, 1);
        setDataBanHang(obj);

        // const listNew = obj.lstChiTiet.splice(index, 1);
        const listSPNhom = [];
        obj.lstChiTiet.map((cate, i) => {
            let sum = 0;
            let itemNew = {};
            if (cate.Attributes.length > 0 && cate.IdNhomSPCha !== 0) {

                sum = cate.Attributes.reduce(function (prev, current) {
                    return (prev += convertToNumber(current.Values));
                }, 0);
                itemNew.Values = sum;
                itemNew.TenNhomSPCha = cate.TenNhomSPCha;
                itemNew.IdNhomSPCha = cate.IdNhomSPCha;

                listSPNhom.push(itemNew);
            }
        });
        setListNhomSP(listSPNhom);

        //  TinhTong();

        // let sum = 0;
        // if (item.Attributes.length > 0) {
        //   sum = item.Attributes.reduce(function (prev, current) {
        //     return (prev += convertToNumber(current.Values));
        //   }, 0);
        // }
        // var lst = listNhomSP.filter((x) => x.Values !== sum);
        // console.log(lst, "lstlstlstlstlstlst");
        // setListNhomSP(lst);
        //
    };

    //
    const updateTextValue1 = (field, e, index) =>
        updateMain(field, e.target.value, index);
    const updateMain = (field, value, index) => {
        const obj = { ...dataBanHang };
        var lstNew = obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                cate[field] = value;
            }
            return cate;
        });
        obj.lstChiTiet = lstNew;
        setDataBanHang(obj);
        // TinhTong();
    };

    const onChangeCheck = (field, e, index) =>
        updateCheck(field, e.target.checked, index);
    const updateCheck = (field, value, index) => {
        const obj = { ...dataBanHang };
        var lstNew = obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                cate[field] = value;
            }
            return cate;
        });
        obj.lstChiTiet = lstNew;
        setDataBanHang(obj);
        // TinhTong();
    };
    //
    // Số lượng
    const onChangeText = (field, e, index) => updateDanhSach(field, e, index);
    const updateDanhSach = (field, e, index) => {
        setValueSanPham(0);
        const obj = { ...dataBanHang };
        let chenhlech = 0;

        var lstNew = obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                let slHientai =
                    !cate.SLDonViBan || cate.SLDonViBan.trim() === ""
                        ? 0
                        : parseFloat(cate.SLDonViBan);
                var value = e.target.validity.valid ? e.target.value : cate[field];

                chenhlech = slHientai - value;
                // const value = e.target.validity.valid ? e.target.value : cate[field];
                cate[field] = value;
                //Chheck bán âm
                if (dataBanHang.ConfigBanAm === false) {
                    if (convertToNumber(cate[field]) > cate.SLTonThucTe) {
                        pushNotification(
                            "Trong kho không đủ số lượng để bán",
                            "error",
                            "TOP_RIGHT",
                            2000
                        );
                    }
                }
                //End check bán âm

                cate.ValueOfUnitForExportPrice = cate.SLDonViBan;

                if (cate.Attributes.length > 0) {
                    cate.Attributes.map((attr, i) => {
                        if (attr.RatioDifferentNew > 0) {

                            attr.Values = numeral(
                                attr.RatioDifferentNew *
                                cate[field].replace(/,/g, "").replace(/-/g, "")
                            )
                                .format("0.[0000]")
                                .doidau();
                        } else {

                            // cập nhật sai số lượng của TTK  => tuandh : 13/10/2025 sửa lại thành attr.Ratio

                            attr.Values = numeral(
                                attr.Ratio * cate[field].replace(/,/g, "").replace(/-/g, "")
                            ).format("0.[0000]");
                        }
                    });
                }
            }
            return cate;
        });
        obj.lstChiTiet = lstNew;
        setDataBanHang(obj);
        obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                const lstCkNew = listChietKhauNhom.map((cateDetail, ii) => {
                    if (cate.IdNhomSPCha === cateDetail.IdNhomSPCha) {
                        if (cate.Attributes.length > 0 && cate.IdNhomSPCha !== 0) {
                            var ChietKhauTheoKG = cate.Attributes.find(
                                (e) => e.Name.toLowerCase().trim() === "kg"
                            );
                            if (typeof ChietKhauTheoKG === "undefined") {
                                return null;
                            }
                            if (ChietKhauTheoKG.RatioDifferent) {
                                var sl =
                                    chenhlech * parseFloat(ChietKhauTheoKG.RatioDifferent ?? 1);
                                cateDetail.SoLuong =
                                    convertToNumber(cateDetail.SoLuong) - convertToNumber(sl);
                            }
                        }
                    }
                    return cateDetail;
                });
                setListChietKhauNhom(lstCkNew);
            }
        });
        // TinhTong();
    };

    const onChangeText3 = (field, e, index) => updateDanhSach3(e, field, index);
    const updateDanhSach3 = (e, field, index) => {
        setValueSanPham(0);
        const obj = { ...dataBanHang };
        var lstNew = obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                const value = e.target.validity.valid ? e.target.value : cate[field];
                cate[field] = value;
            }
            return cate;
        });
        obj.lstChiTiet = lstNew;
        setDataBanHang(obj);
        // TinhTong();
    };
    const onChangeGTGT = (field, e, index) => {
        const obj = { ...dataBanHang };
        var lstNew = obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                cate[field] = convertToNumber(e.target.value);
            }
            return cate;
        });
        obj.lstChiTiet = lstNew;
        setDataBanHang(obj);
    };

    const onChangeThueGTGT = (field, e, index) => {
        const obj = { ...dataBanHang };
        var lstNew = obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                const value = e.target.validity.valid ? e.target.value : cate[field];
                cate[field] = value;
            }
            return cate;
        });
        obj.lstChiTiet = lstNew;
        setDataBanHang(obj);
    };
    const onChangeDate = (field, e, index) => updateDate(e, field, index);
    const updateDate = (e, field, index) => {
        const obj = { ...dataBanHang };
        var lstNew = obj.lstChiTiet.map((cate, i) => {
            if (index === i) {
                cate[field] = e;
            }
            return cate;
        });
        obj.lstChiTiet = lstNew;
        setDataBanHang(obj);
    };
    const [numberLamTronSoLuong, setNumberLamTronSoLuong] = useState(-1);
    useEffect(() => {
        DanhMucNewApi.getConfigByKey({ key: "LamTronSoLuong" }).then((response) => {
            if (response && response.data) {
                setNumberLamTronSoLuong(response.data.Value);
            }
        });
    }, []);
    const listItem = () => {
        dataBanHang.TotalAmount = 0;
        dataBanHang.TotalAmountThueGTGT = 0;
        dataBanHang.TotalAmountNew = 0;
        if (dataBanHang.lstChiTiet != null) {
            dataBanHang.lstChiTiet = dataBanHang.lstChiTiet.sort(
                (a, b) => a.ThuTuHienThi - b.ThuTuHienThi
            );
        }
        return (
            dataBanHang.lstChiTiet != null &&
            dataBanHang.lstChiTiet.map((category, index) => {
                var tong = 0;
                var strAttribute = "";
                var valueAttribute = 0;
                var AttributeDonVi = "";
                var sDonVi = "";
                var sDonViBanTTK = "";
                var checkAttr = false;
                category.ValueOfUnitForExportPrice = (
                    category.ValueOfUnitForExportPrice + ""
                )
                    .replace(/,/g, "")
                    .replace(/-/g, "");
                if (category.Attributes.length > 0) {
                    var attrMain = category.Attributes.find(
                        (e) => e.AttributeID === category.IdDonViXuat
                    );

                    if (
                        typeof category.LstDonViNhap != "undefined" &&
                        typeof attrMain != "undefined"
                    ) {
                        var attrFilter = dataBanHang.lstChiTiet[index].LstDonViNhap.find(
                            (e) => e.AttributeID == category.IdDonViXuatView
                        );

                        if (attrFilter != null) {
                            var attrChon = { ...attrFilter };

                            attrChon.Values =
                                dataBanHang.lstChiTiet[index].ValueOfUnitForExportPrice;
                            attrChon.isCheck = true;
                            if (attrMain != null) {
                                let indexBlock = 0;
                                category.Attributes.map((Attribute, i) => {
                                    if (Attribute.AttributeID == category.IdDonViXuat) {
                                        indexBlock = i;
                                    }
                                });
                                category.ValueOfUnitForExportPrice = attrMain.Values;
                                // category.Attributes.splice(indexBlock, 1);
                                dataBanHang.lstChiTiet[index].Attributes.splice(indexBlock, 1);
                                dataBanHang.lstChiTiet[index].Attributes.push(attrChon);
                                // category.Attributes.push(attrChon);
                            }
                        }
                    }

                    if (valueAttribute == 0) {
                        category.Attributes.map((Attribute, i) => {
                            if (Attribute.isCheck) {
                                valueAttribute = Attribute.Values;
                                AttributeDonVi = Attribute.Name;
                            } else if (Attribute.IsBanTTK) {
                                valueAttribute = Attribute.Values;
                                AttributeDonVi = Attribute.Name;
                            }
                        });
                    }
                    // bán ttk
                    // End bán ttk
                    category.Attributes.map((Attribute, index) => {
                        //
                        // 
                        if (Attribute.Values && Attribute.isCheck && Attribute.IsBanTTK) {
                            if (strAttribute != "") {
                                strAttribute =
                                    strAttribute +
                                    ", " +
                                    formatNumber(Attribute.Values) +
                                    " " +
                                    Attribute.Name;
                            } else {
                                strAttribute =
                                    "(" + formatNumber(Attribute.Values) + " " + Attribute.Name;
                            }
                        } else {
                            if (Attribute.Values && Attribute.isCheck) {
                                if (strAttribute != "") {
                                    strAttribute =
                                        strAttribute +
                                        ", " +
                                        Attribute.Values +
                                        " " +
                                        Attribute.Name;
                                } else {
                                    strAttribute =
                                        "(" + formatNumber(Attribute.Values) + " " + Attribute.Name;
                                }
                            }
                            if (Attribute.Values && Attribute.IsBanTTK) {
                                if (strAttribute != "") {
                                    strAttribute =
                                        strAttribute +
                                        ", " +
                                        Attribute.Values +
                                        " " +
                                        Attribute.Name;
                                } else {
                                    strAttribute =
                                        "(" + formatNumber(Attribute.Values) + " " + Attribute.Name;
                                }
                            }
                        }
                    });
                    if (strAttribute != "") {
                        strAttribute = strAttribute + ")";
                    }
                }
                category.strAttribute = strAttribute;
                // category.strAttributeBanTTK = strAttributeBanTTK;
                if (
                    category.DonVi != null &&
                    category.DonVi != "" &&
                    typeof category.DonVi != "undefined"
                ) {
                    sDonVi = category.DonVi;
                } else if (category.DonViGiaCong != null) {
                    sDonVi = category.DonViGiaCong;
                } else {
                    sDonVi = category.DonViXuat;
                    // if (typeof sDonViXuat === "undefined") {
                    //   sDonVi = category.DonViNhap;
                    // }
                }
                if (valueAttribute != 0) {
                    sDonVi = AttributeDonVi;
                    if (category.ShowQuantity || category.IsBanBuon) {
                        tong = valueAttribute * CustomerParseFloat(category.Quantity);
                    } else {
                        tong = valueAttribute;
                    }
                } else {
                    if (category.ShowQuantity || category.IsBanBuon) {
                        if (category.RateForSale > 0) {
                            tong =
                                CustomerParseFloat(category.ValueOfUnitForExportPrice) *
                                CustomerParseFloat(category.Quantity) *
                                category.RateForSale;
                        } else {
                            tong =
                                CustomerParseFloat(category.ValueOfUnitForExportPrice) *
                                CustomerParseFloat(category.Quantity);
                        }
                    } else {
                        if (category.RateForSale > 0) {
                            tong =
                                CustomerParseFloat(category.ValueOfUnitForExportPrice) *
                                category.RateForSale;
                        } else {
                            tong = CustomerParseFloat(category.ValueOfUnitForExportPrice);
                        }
                    }
                }
                tong = CustomerParseFloat(numeral(tong));
                category.Tong = CustomerParseFloat(numeral(tong));
                //
                category.SLDonViBan = category.ValueOfUnitForExportPrice;
                category.ExportPrice = numeral(category.ExportPrice)
                    .format("0.[0000]")
                    .doidau();
                const totalXuat = category.Price * category.Tong;
                dataBanHang.TotalAmount =
                    dataBanHang.TotalAmount + category.Price * category.Tong;
                const sumQuantityExportXuat = dataBanHang.lstChiTiet.reduce(function (
                    total,
                    current
                ) {
                    var tongNew = 0;
                    var valueAttributeNew = 0;
                    var AttributeDonViNew = "";
                    if (current.Attributes.length > 0) {
                        if (valueAttributeNew == 0) {
                            current.Attributes.map((Attribute, i) => {
                                if (Attribute.isCheck) {
                                    valueAttributeNew = Attribute.Values;
                                    AttributeDonViNew = Attribute.Name;
                                }
                            });
                        }
                    }
                    if (valueAttributeNew != 0) {
                        if (current.ShowQuantity || category.IsBanBuon) {
                            tongNew =
                                valueAttributeNew * CustomerParseFloat(current.Quantity);
                        } else {
                            tongNew = valueAttributeNew;
                        }
                    } else {
                        if (current.ShowQuantity || category.IsBanBuon) {
                            tongNew =
                                CustomerParseFloat(current.ValueOfUnitForExportPrice) *
                                CustomerParseFloat(current.Quantity) *
                                current.RateForSale;
                        } else {
                            if (current.OptionID > 0) {
                                tongNew =
                                    CustomerParseFloat(current.ValueOfUnitForExportPrice) *
                                    current.RateForSale;
                            } else {
                                tongNew = CustomerParseFloat(current.ValueOfUnitForExportPrice);
                            }
                        }
                    }
                    tongNew = CustomerParseFloat(numeral(tongNew));
                    return total + tongNew;
                },
                    0);
                category.tongNew = sumQuantityExportXuat;
                const totalChietKhauNhom = listChietKhauNhom.reduce(
                    (a, v) => (a = a + v.TienChietKhau * v.SoLuong),
                    0
                );
                const newChietKhauGTGT =
                    (convertToNumber(dataBanHang.ChietKhau) +
                        convertToNumber(totalChietKhauNhom)) /
                    sumQuantityExportXuat;
                const newPrice = category.Price - newChietKhauGTGT;
                const GTGTXuat = category.ThueGTGT / 100;
                category.PriceGTGT = newPrice * GTGTXuat * category.Tong;

                dataBanHang.TotalAmountThueGTGT = numeral(
                    CustomerParseFloat(dataBanHang.TotalAmountThueGTGT) +
                    (CustomerParseFloat(category.ThueGTGT) *
                        CustomerParseFloat(category.Tong) *
                        newPrice) /
                    100
                ).format("0");

                dataBanHang.TotalAmountNew =
                    CustomerParseFloat(dataBanHang.TotalAmount) +
                    CustomerParseFloat(dataBanHang.TotalAmountThueGTGT);

                if (sCode > 0) {
                    dataBanHang.TongTienConNo =
                        CustomerParseFloat(dataBanHang.TotalAmount) +
                        CustomerParseFloat(dataBanHang.OtherFee) -
                        CustomerParseFloat(dataBanHang.ChietKhau) -
                        CustomerParseFloat(dataBanHang.TotalPaid) -
                        CustomerParseFloat(dataBanHang.TongTienDaThanhToan);
                }
                var saleTime = category.SaleTime;
                if (typeof category.SaleTime == "string" && category.SaleTime != null) {
                    saleTime = convertDate(category.SaleTime);
                }
                if (category.SaleTime == null) {
                    saleTime = dataBanHang.CreatedTime;
                }

                if (category.ProductID > 0) {
                    category.isNXCuon = true;
                }
                let kieugiacongxago = false;
                category.Options.map((op) => {
                    if (
                        isKGCXaGo == true &&
                        op.OptionID == category.OptionID &&
                        op.Name.toLowerCase().trim().includes("xà gồ")
                    ) {
                        kieugiacongxago = true;
                    }
                });
                if (category.RateForSale !== 1) {
                    category.RateForSale1 = CustomerParseFloat(
                        numeral(category.RateForSale)
                    );
                } else {
                    category.RateForSale1 = CustomerParseFloat(
                        numeral(category.RateForSale)
                    );
                }
                //
                tong =
                    numberLamTronSoLuong > -1
                        ? formatNumber2Digits(tong, numberLamTronSoLuong)
                        : tong;

                let isDoneGiaoNhan = false;

                if (isSuaDonBanGiaoNhan == true) {
                    isDoneGiaoNhan =
                        category.IdPhieuGiaoNhan > 0 && category.IdPhieuGiaoNhan > 0;
                }

                console.log("isDoneGiaoNhan", isDoneGiaoNhan);

                return (
                    <>
                        <tr key={index}>
                            <td class="text-center">{index + 1}</td>

                            <td class="table-text-left">
                                {dataBanHang.ConfigSuaSanPhamBanHang === true ? (
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        value={category.CategoryName}
                                        onChange={(e) => updateTextValue1("CategoryName", e, index)}
                                        disabled={category.isSanXuat == true ? true : disEditAll}
                                    />
                                ) : (
                                    category.CategoryName
                                )}
                            </td>

                            {dataBanHang.isShowThueGTGT === true && (
                                <td
                                    class="text-center"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    {isNhapThueGTGT === true ? (
                                        <>
                                            <NumberFormat
                                                type="text"
                                                className="form-control text-right"
                                                pattern="[0-9.]*"
                                                value={category.ThueGTGT === 0 ? "" : category.ThueGTGT}
                                                //onChange={(e) => onChangeThueGTGT("ThueGTGT", e, index)}
                                                placeholder="0"
                                                disabled={true}
                                                style={{
                                                    width: "50%",
                                                }}
                                            />
                                            <span>%</span>
                                        </>
                                    ) : (
                                        <select
                                            class="form-control "
                                            value={category.ThueGTGT}
                                            // onChange={(e) => onChangeGTGT("ThueGTGT", e, index)}
                                            disabled={true}
                                        >
                                            <option value="0">0 %</option>
                                            <option value="5">5 %</option>
                                            <option value="8">8 %</option>
                                            <option value="10">10 %</option>
                                        </select>
                                    )}
                                </td>
                            )}

                            {dataBanHang.configDateChiTietDH === true && (
                                <td class="text-left-main">
                                    <DateTimePicker
                                        format={"DD/MM/YYYY HH:mm:ss"}
                                        time={false}
                                        culture="vi"
                                        value={saleTime}
                                        disabled={disEditAll}
                                        onChange={(e) => onChangeDate("SaleTime", e, index)}
                                    />
                                </td>
                            )}

                            <td class="">
                                {category.Options.length > 0 && (
                                    <select
                                        class="form-control selectCss"
                                        value={category.OptionID}
                                        onChange={(e) => onChangeOption("OptionID", e, index)}
                                        disabled={
                                            category.isNXCuon === true || category.isSanXuat == true
                                                ? true
                                                : disEditAll
                                        }
                                    >
                                        {category.Options.map((option, i) => {
                                            const { Name, OptionID } = option;
                                            return <option value={OptionID}>{Name}</option>;
                                        })}
                                    </select>
                                )}
                            </td>
                            <td>
                                {category.ShowQuantityNew == true ||
                                    category.IsBanBuon == true ? (
                                    <div class="from-table-input">
                                        <span class="nhan-bh1">{strAttribute}</span>
                                        <NumberFormat
                                            class="form-control text-right"
                                            pattern="[0-9,.]*"
                                            value={category.SLDonViBan}
                                            thousandSeparator={true}
                                            disabled={
                                                category.CongThucSanPham.CongThucID > 0
                                                    ? true
                                                    : isDoneGiaoNhan == true
                                                        ? false
                                                        : disEditAll
                                            }
                                            onChange={(e) => onChangeText("SLDonViBan", e, index)}
                                        />
                                        {kieugiacongxago === true && (
                                            <span class="nhan-bh1"> m x</span>
                                        )}
                                        {kieugiacongxago === false && (
                                            <span class="nhan-bh1"> {category.DonViXuat} x</span>
                                        )}
                                        {/* <span class="nhan-bh1"> {category.DonViXuat} x</span> */}
                                        {category.OptionID != 0 && category.RateForSale != 1 && (
                                            <>
                                                <span>{category.RateForSale1}</span>
                                                <span class="nhan-bh1"> x</span>
                                            </>
                                        )}
                                        <NumberFormat
                                            class="form-control text-right"
                                            pattern="[0-9]*"
                                            value={category.Quantity}
                                            // thousandSeparator={true}
                                            disabled={
                                                category.isNXCuon === true || category.isSanXuat == true
                                                    ? true
                                                    : isDoneGiaoNhan == true
                                                        ? false
                                                        : disEditAll
                                            }
                                            onChange={(e) => onChangeText3("Quantity", e, index)}
                                        />{" "}
                                        <span>
                                            ={" "}
                                            <NumberFormat
                                                class="text-right"
                                                value={category.Tong}
                                                thousandSeparator={true}
                                                displayType={"text"}
                                            />{" "}
                                            {sDonVi}
                                        </span>{" "}
                                        <span className="form-add-BH">
                                            x{" "}
                                            <NumberFormat
                                                class="text-right"
                                                value={category.Price}
                                                thousandSeparator={true}
                                                displayType={"text"}
                                            />
                                            {/* <BtnSuaGia
                                                class="ml-2"
                                                category={category}
                                                index={index}
                                                dataBanHang={dataBanHang}
                                                setDataBanHang={setDataBanHang}
                                                disEditDonGia={disEditDonGia}
                                                isCanhBaoBanGiaTrungBinh={isCanhBaoBanGiaTrungBinh}
                                                isDoneGiaoNhan={isDoneGiaoNhan}
                                            /> */}

                                            {" "}
                                            đ ={" "}
                                            <NumberFormat
                                                class="text-right"
                                                displayType={"text"}
                                                value={numeral(category.Price * category.Tong).format(
                                                    "0.[0000]"
                                                )}
                                                thousandSeparator={true}
                                            />{" "}
                                            đ
                                        </span>
                                    </div>
                                ) : null}
                                {category.ShowQuantity == true && category.IsBanBuon != true ? (
                                    <div class="from-table-input">
                                        <span class="nhan-bh1">{strAttribute}</span>
                                        <NumberFormat
                                            class="form-control text-right"
                                            pattern="[0-9,.]*"
                                            value={category.SLDonViBan}
                                            thousandSeparator={true}
                                            disabled={
                                                category.CongThucSanPham.CongThucID > 0 ||
                                                    category.isSanXuat == true
                                                    ? true
                                                    : isDoneGiaoNhan == true
                                                        ? false
                                                        : disEditAll
                                            }
                                            onChange={(e) => onChangeText("SLDonViBan", e, index)}
                                        />
                                        {kieugiacongxago === true && (
                                            <span class="nhan-bh1"> m x</span>
                                        )}
                                        {kieugiacongxago === false && (
                                            <span class="nhan-bh1"> {category.DonViXuat} x</span>
                                        )}
                                        {/* <span class="nhan-bh1"> {category.DonViXuat} x</span> */}
                                        {category.OptionID != 0 && category.RateForSale != 1 && (
                                            <>
                                                <span>{category.RateForSale1}</span>
                                                <span class="nhan-bh1"> x</span>
                                            </>
                                        )}
                                        <NumberFormat
                                            class="form-control text-right"
                                            pattern="[0-9]*"
                                            value={category.Quantity}
                                            // thousandSeparator={true}
                                            disabled={
                                                category.isNXCuon === true || category.isSanXuat == true
                                                    ? true
                                                    : isDoneGiaoNhan == true
                                                        ? false
                                                        : disEditAll
                                            }
                                            onChange={(e) => onChangeText3("Quantity", e, index)}
                                        />{" "}
                                        <span>
                                            ={" "}
                                            <NumberFormat
                                                class="text-right"
                                                value={category.Tong}
                                                thousandSeparator={true}
                                                displayType={"text"}
                                            />{" "}
                                            {sDonVi}
                                        </span>{" "}
                                        <span className="form-add-BH">
                                            x{" "}
                                            <NumberFormat
                                                class="text-right"
                                                value={category.Price}
                                                thousandSeparator={true}
                                                displayType={"text"}
                                            />
                                            {/* <BtnSuaGia
                                                class="ml-2"
                                                category={category}
                                                index={index}
                                                dataBanHang={dataBanHang}
                                                setDataBanHang={setDataBanHang}
                                                disEditDonGia={disEditDonGia}
                                                isCanhBaoBanGiaTrungBinh={isCanhBaoBanGiaTrungBinh}
                                                isDoneGiaoNhan={isDoneGiaoNhan}
                                            /> */}
                                            {" "}
                                            đ ={" "}
                                            <NumberFormat
                                                class="text-right"
                                                displayType={"text"}
                                                value={numeral(category.Price * category.Tong).format(
                                                    "0.[0000]"
                                                )}
                                                thousandSeparator={true}
                                            />{" "}
                                            đ
                                        </span>
                                    </div>
                                ) : null}

                                {category.ShowQuantity != true &&
                                    category.ShowQuantityNew != true &&
                                    category.IsBanBuon != true ? (
                                    <div class="from-table-input">
                                        {strAttribute != "" && (
                                            <span
                                                class="sl-bh"
                                                style={{ whiteSpace: "pre-wrap !important" }}
                                            >
                                                {" "}
                                                {strAttribute}
                                            </span>
                                        )}
                                        <NumberFormat
                                            class="form-control text-right"
                                            pattern="[0-9,.]*"
                                            value={category.SLDonViBan}
                                            thousandSeparator={true}
                                            disabled={
                                                category.CongThucSanPham.CongThucID > 0 ||
                                                    category.isSanXuat == true
                                                    ? true
                                                    : isDoneGiaoNhan == true
                                                        ? false
                                                        : disEditAll
                                            }
                                            onChange={(e) => onChangeText("SLDonViBan", e, index)}
                                        />
                                        <span class="sl-bh"> {category.DonViXuat} </span>{" "}
                                        {category.OptionID != 0 && category.RateForSale != 1 && (
                                            <>
                                                <span class="nhan-bh1"> x</span>
                                                <span>{category.RateForSale}</span>
                                            </>
                                        )}
                                        <span>
                                            ={" "}
                                            <NumberFormat
                                                class="text-right"
                                                value={category.Tong}
                                                thousandSeparator={true}
                                                displayType={"text"}
                                            />{" "}
                                            {sDonVi}
                                        </span>{" "}
                                        <span className="form-add-BH">
                                            x{" "}
                                            <NumberFormat
                                                class="text-right"
                                                value={category.Price}
                                                thousandSeparator={true}
                                                displayType={"text"}
                                            />
                                            {/* <BtnSuaGia
                                                class="ml-2"
                                                category={category}
                                                index={index}
                                                dataBanHang={dataBanHang}
                                                setDataBanHang={setDataBanHang}
                                                disEditDonGia={disEditDonGia}
                                                isCanhBaoBanGiaTrungBinh={isCanhBaoBanGiaTrungBinh}
                                                isDoneGiaoNhan={isDoneGiaoNhan}
                                            /> */}
                                            {" "}
                                            đ ={" "}
                                            <NumberFormat
                                                class="text-right"
                                                displayType={"text"}
                                                value={numeral(category.Price * category.Tong).format(
                                                    "0.[0000]"
                                                )}
                                                thousandSeparator={true}
                                            />{" "}
                                            đ
                                        </span>
                                    </div>
                                ) : null}

                                <div class="align-centerNew ">
                                    <div class="form-new-input-left textArea-w" style={{ marginTop: "5px" }}>
                                        <textarea
                                            class="form-control"
                                            id="idGhiChu"
                                            rows="1"
                                            onChange={(e) => updateTextValue1("Note", e, index)}
                                            value={category.Note ?? ""}
                                            disabled={
                                                category.isSanXuat == true
                                                    ? true
                                                    : isDoneGiaoNhan == true
                                                        ? false
                                                        : disEditAll
                                            }
                                        //disabled={category.isSanXuat == true ? true : disEditAll}
                                        ></textarea>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center-main">
                                {/* {roleSuaSP && (
                                    <BtnChiTietSp
                                        category={category}
                                        index={index}
                                        dataBanHang={dataBanHang}
                                        setDataBanHang={setDataBanHang}
                                        objDataStore={objDataStore}
                                        GoiPhanMem={GoiPhanMem}
                                        HienthiAutotrukhogiacong={HienthiAutotrukhogiacong}
                                        tatCanhBaoLuongTon={tatCanhBaoLuongTon}
                                        disEditAll={disEditAll}
                                        disEditDonGia={disEditDonGia}
                                        isNhapCongThucNhanhTTK={isNhapCongThucNhanhTTK}
                                        isNhapThueGTGT={isNhapThueGTGT}
                                        isShowGiaBan={isShowGiaBan}
                                        isCanhBaoBanGiaTrungBinh={isCanhBaoBanGiaTrungBinh}
                                        roleBanCuon={roleBanCuon}
                                        roleMaMc={roleMaMc}
                                        roleGiaVon={roleGiaVon}
                                    />
                                )} */}
                                {disEditAll !== true && category.isSanXuat != true && (
                                    <a
                                        href={() => false}
                                        onClick={(e) => DeleteCategory(index)}
                                        class="iconTable-Main"
                                    >
                                        <img src={Trash} title="Xoá" alt="" />
                                    </a>
                                )}
                            </td>
                        </tr>
                    </>
                );
            })
        );
    };
    return (
        <>
            <div class="table-Main-content table-dateitme">
                <table class="table">
                    <thead>
                        <tr class="heade-main">
                            <th class="text-left-main w-new-5">
                                <span>STT</span>
                            </th>

                            <th class="text-left-main">
                                <span>Tên hàng</span>
                            </th>
                            {dataBanHang.isShowThueGTGT === true && (
                                <th class="text-center-main">
                                    <span>Thuế GTGT</span>
                                </th>
                            )}
                            {dataBanHang.configDateChiTietDH === true && (
                                <th class="text-center-main">
                                    <span>Thời gian</span>
                                </th>
                            )}

                            <th class="text-center-main">
                                <span>Kiểu gia công</span>
                            </th>
                            <th class="text-left-main">Ghi chú</th>

                            <th class="text-center-main w-new-5">Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>{listItem()}</tbody>
                </table>
            </div>
        </>
    );
};
